import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import { getSingleDroneJob } from "../../redux/slice/droneJobsSlice";
import location_icon from "../../assets/image/png/loction_icon.png";
import blue_bag from "../../assets/image/png/blue_bag.png";
import HowWeCanHelp from "../common/HowWeCanHelp";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SchoolIcon from '@mui/icons-material/School';
import PinDropIcon from '@mui/icons-material/PinDrop';
import WorkIcon from '@mui/icons-material/Work';
import UpdateIcon from '@mui/icons-material/Update';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import GroupIcon from '@mui/icons-material/Group';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; // for Sales
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { useNavigate } from 'react-router-dom';


const JobsHireDetailsHero = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Hook to navigate programmatically
  const { id } = useParams();
  const { droneJobDetails } = useSelector((state) => state.droneJob);

  useEffect(() => {
    dispatch(getSingleDroneJob(id));
  }, [id, dispatch]);

  const openModal = () => {
    // Use navigate to redirect to the registration form with the jobId in the URL
    navigate(`/quick-registration-form/${droneJobDetails?._id}`);
  };

  return (
    <div className="pt-5">
      <div className="py-4">
        <div className="container">
          <h3 className="fs_21 fw-normal ff_inter color_darkgray">
            <span className="color_blue py-2">
              <Link to="/jobs-hire-page" className="custom-color">Jobs & Hire</Link>
            </span>{" "} 
            / {droneJobDetails?.title}
          </h3>
        </div>
      </div>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 pe-3 pe-lg-5">
            <div className="job-details-card">
              <h4>{droneJobDetails?.title}</h4>
              <p>{droneJobDetails?.companyName}</p>
              <div className="job-info">
                <div>
                  <PinDropIcon />
                  <span>Location: {droneJobDetails?.locationName}</span>
                </div>
                <div>
                  <WorkIcon />
                  <span>Experience: {droneJobDetails?.experience} Years</span>
                </div>
                <div>
                  <SchoolIcon />
                  <span>Qualification: {droneJobDetails?.qualification}</span>
                </div>
                <div>
                  <CurrencyRupeeIcon />
                  <span>Salary: {droneJobDetails?.salary}</span>
                </div>
                <div>
                  <UpdateIcon />
                  <span>Posted On: {droneJobDetails?.postedOn}</span>
                </div>
                <div>
                  <GroupIcon />
                  <span>Job Type: {droneJobDetails?.jobType}</span>
                </div>
                <div>
                  <AccessibilityIcon />
                  <span>Gender: {droneJobDetails?.gender}</span>
                </div>
              </div>
            </div>

            <div className="job-summary-card mt-4">
              <h4 className="job-summary-heading fs_43">Job Summary</h4>
              <div className="job-description">
                {HTMLReactParser(droneJobDetails?.jobSummary || " ")}
              </div>
            </div>

            <div className="mt-5">
              <button onClick={openModal} className="apply-btn">
                Apply Now
              </button>
            </div>
          </div>
          <HowWeCanHelp />
        </div>
      </div>
    </div>
  );
};

export default JobsHireDetailsHero;
